import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
   interface Storage {
      isFocused: { isFocused: boolean };
   }
}

export const IsFocused = Extension.create({
   name: 'isFocused',

   addStorage() {
      return {
         isFocused: false,
      };
   },

   // Written from the transaction handler, not onFocus/onBlur: core emits
   // 'transaction' before 'focus'/'blur', so a useEditorState selector that
   // runs on the transaction would otherwise read the previous value.
   onTransaction({ transaction }) {
      if (transaction.getMeta('focus')) {
         this.storage.isFocused = true;
      }
      if (transaction.getMeta('blur')) {
         this.storage.isFocused = false;
      }
   },
});
